export default __webpack_public_path__ + "static/X02-bcc6152eba2abf09d777f3517851fd11.png";